import React from "react";

const isRef = (obj: any): obj is React.MutableRefObject<unknown> =>
  obj && obj.hasOwnProperty("current");

export default isRef;
